﻿let configSource = document.documentElement;
let rootUrl = null;
let config = null;

function setConfigSource(element) {
	if (configSource !== element) {
		configSource = element;
		config = null;
	}
}

function getRootUrl() {
	if (!rootUrl) {
		const result = configSource.dataset.rootUrl ?? window.gRootURL;
		// not a string or non-empty string is not slash-prefixed
		if (typeof result != "string" || result.length != 0 && result[0] !== "/")
			throw new Error("Invalid root URL");
		rootUrl = result;
	}
	return rootUrl;
}

function getBuildVersion() {
	return configSource.dataset.buildVersion;
}

function getMaxRequestLength() {
	return +configSource.dataset.maxRequestLength || 100 * 1024 * 1024;
}

function ensureConfig() {
	config ??= (JSON.parse(configSource.dataset.apiConfig ?? null) ?? window.gApiConfig);
}

function getApiConfig(key) {
	ensureConfig();
	return config?.[key];
}

export { setConfigSource, getRootUrl, getApiConfig, getBuildVersion, getMaxRequestLength };